import { OpenAPI } from '../api/core/OpenAPI';
import { store } from '../redux/store';
import type { MyActivityResponse } from '../types/myActivity.types';

/**
 * Inicio "Mi actividad": today's counters (range in the client's timezone) + last 5 sales
 * of the logged-in user.
 */
export async function fetchMyActivity(
  range: { from: string; to: string },
  signal?: AbortSignal,
): Promise<MyActivityResponse> {
  const apiBaseUrl = OpenAPI.BASE;
  const token = store.getState().auth.token ?? '';

  if (token === '') {
    throw new Error('No se encontró token de autenticación.');
  }

  const url = new URL(`${apiBaseUrl}/dashboard/my-activity`);
  url.searchParams.set('from', range.from);
  url.searchParams.set('to', range.to);

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      message: 'Error desconocido',
    }));
    throw new Error(
      (errorData as { message?: string }).message ??
        `Error ${response.status}: ${response.statusText}`,
    );
  }

  const data = (await response.json()) as MyActivityResponse;
  return {
    today: {
      salesCount: Number(data?.today?.salesCount ?? 0),
      piecesSold: Number(data?.today?.piecesSold ?? 0),
      pendingPayment: Number(data?.today?.pendingPayment ?? 0),
    },
    recentSales: (data?.recentSales ?? []).map((s) => ({
      ...s,
      totalAmount: Number(s.totalAmount),
      itemsCount: Number(s.itemsCount),
    })),
  };
}
